module.exports = __webpack_public_path__ + "img/descarga-icon-old.5e03c3e4.png";